import { constantsTypes } from "../reduxConstants";

const initialValue = {};

export const MobilenowShowingMoviesReduce = (state = initialValue, action) => {
  switch (action.type) {
    case constantsTypes.MOBILE_NOW_SHOWING_MOVIE:
      return action.value;
    default:
      return state;
  }
};
